import { APILanguage } from '../types/api';

export const mapLanguageToApiLanguage = (language: string | null): APILanguage => {
    switch (language) {
      case 'en':
        return APILanguage.English;
      case 'fr':
        return APILanguage.French;
      case 'es':
        return APILanguage.Spanish;
      default:
        return APILanguage.English;
    }
  };